export default "<p>arqueo-cajas works!</p>\n"